import { useQuery } from '@tanstack/react-query';

import {
  detectKpiAnomalies,
  DetectKpiAnomaliesParams,
  KpiAnomaly,
} from '@/features/insights/api/detect-kpi-anomalies';

export const getKpiAnomaliesQueryKey = (params: DetectKpiAnomaliesParams) => [
  'kpiAnomalies',
  params.kpiId,
  params.projectId,
  params.monthsBack,
  params.periodType,
  params.fromDate?.getTime(),
  params.toDate?.getTime(),
];

export function useKpiAnomalies(params: DetectKpiAnomaliesParams) {
  return useQuery<KpiAnomaly[]>({
    queryKey: getKpiAnomaliesQueryKey(params),
    queryFn: () => detectKpiAnomalies(params),
    enabled: !!params.kpiId && !!params.projectId,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
